export default __webpack_public_path__ + "static/media/photo9.8675a96d.jpg";